import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export default async function setLotToPending(lotId) {
	var lotRef = firebaseRef.ref(
		'/kavtek_lots/' + PROJECT_CODE.projectCode + '/' + Number(lotId)
	);

	var availability = lotRef.child('available');
	var isReturned = false;

	await availability.transaction(
		(data) => {
			if (data === 'available') {
				return 'pending';
			} else if (data === 'pending') {
				return;
			} else if (data === 'hold') {
				return;
			} else {
				return;
			}
		},
		(error, committed, snapshot) => {
			if (error) {
				console.error('Oops, something abnormal happened', error);
			} else if (!committed) {
				console.error('Oops, the data was already updated.');
			} else {
				console.log('The data has been updated successfully!');
				isReturned = true;
			}
		}
	);

	if (isReturned === true) {
		console.log('You updated the data successfully');
	}
	return isReturned;
}
